@import '../../../globals/main.scss';

pn-profile-modal-profile {
  &[selected='false'] {
    pn-profile-modal-type[selected='true']:not([selected-profile='']) & {
      display: none;
    }
  }
}
.pn-profile-modal-profile-listitem {
  overflow: hidden;
  max-height: 10rem;
  transition: max-height 0.15s ease;
  opacity: 1;
  &[aria-hidden='true'] {
    max-height: 0;
    opacity: 0;
  }
}

.pn-profile-modal-profile-listitem-button {
  padding: 0.8rem;
  margin: 0;
  background: $white;
  outline: 0;
  appearance: none;
  border: 0;
  cursor: pointer;
  border-radius: 0.8rem;
  transition: background 0.15s ease;
  text-align: left;
  width: 100%;
  &:hover,
  &:focus,
  &:active {
    background: $blue25;
  }
  .pn-profile-modal-profile-listitem[aria-hidden='true'] & {
    display: none;
  }
}
.pn-profile-modal-profile-listitem-heading {
  color: $blue700;
  font-weight: 700;
  font-size: 1.6rem;
}
.pn-profile-modal-profile-listitem-description {
  color: $gray700;
  font-weight: 400;
  font-size: 1.2rem;
}

.pn-profile-modal-profile-details {
  max-height: 300rem;
  transition: max-height 0.15s ease;
  opacity: 1;
  &[aria-hidden='true'] {
    max-height: 0;
    opacity: 0;
    overflow: hidden;
  }
  > pn-button {
    position: relative;
    margin-left: -1.2rem;

    .pn-button-content {
      font-weight: 500;
    }
  }
}

.pn-profile-modal-profile-details-company {
  border-top: 1px solid $gray200;
  border-bottom: 1px solid $gray200;
  padding: 0.8rem 0.8rem;
  margin: 1.6rem 0;
}
.pn-profile-modal-profile-details-label {
  font-size: 1.4rem;
  font-weight: 500;
  margin-bottom: 1.2rem;
}

.pn-profile-modal-profile-details-company-heading {
  font-weight: 700;
  font-size: 1.6rem;
}
.pn-profile-modal-profile-details-company-description {
  color: $gray700;
  font-weight: 400;
  font-size: 1.2rem;
}

.pn-profile-modal-profile-details-list {
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
  padding: 0 0;
}

.pn-profile-modal-profile-details-list-label {
  font-size: 1.4rem;
  font-weight: 500;
  margin: 0 0 0 0.8rem;
}
